import styled from 'styled-components';
import { ModalDialog, token } from '@zillow/constellation';

export const StyledZIndexModalDialog = styled(ModalDialog)`
  z-index: ${token('zIndices.dialog')};
`;
